import { render, staticRenderFns } from "./AdminUser.vue?vue&type=template&id=5896d933&scoped=true&"
import script from "./AdminUser.vue?vue&type=script&lang=js&"
export * from "./AdminUser.vue?vue&type=script&lang=js&"
import style0 from "./AdminUser.vue?vue&type=style&index=0&id=5896d933&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5896d933",
  null
  
)

export default component.exports